import { render } from "./DropDownListEscola.vue?vue&type=template&id=941b2376&ts=true"
import script from "./DropDownListEscola.vue?vue&type=script&lang=ts"
export * from "./DropDownListEscola.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__